module.exports = __webpack_public_path__ + "img/Paddington 2 Bingo.99ef53e9.jpeg";